var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Problem-feedback-main",class:{ 'Problem-feedback-main-mobile': _vm.isMobile }},[_c('Base-title',{attrs:{"title":"联系贝壳隐私合规团队"}}),_c('FeedbackType')],1)}
var staticRenderFns = []

export { render, staticRenderFns }